import React from "react";
import { useSelector } from "react-redux";
import { Redirect, Route } from "react-router-dom";

export default function ScheduleRoute({ children, fallbackPath = "/reservas", requireLocationState = false, ...rest }) {
    const { business } = useSelector((store) => store.business);
    return (
        <Route 
            {...rest} render={(routeProps) => {
                const { params } = routeProps.match;
         
                if (!business && params.id) {
                    return <Redirect to={'/business/' + params.id} />;
                }

                if (!business) {
                    return <Redirect to={fallbackPath} />;
                }

                if (requireLocationState && !routeProps.location.state) {
                    return <Redirect to={'/business/' + params.id} />;
                }

                return typeof children === "function" ? children(routeProps) : children;
            }
            } 
        />
    )
}